module.exports = __webpack_public_path__ + "img/quanyi1_icon.2fcb4335.svg";